module.exports = __webpack_public_path__ + "img/search-gold.598eb015.svg";